module.exports = __webpack_public_path__ + "static/media/document-week11.0780787b.pdf";